export default function RoundEnd({ data, myKey, playerName, opponentName, countdown }) {
  const { round, winner, p1_score, p2_score, round_wins, celebrity_name, celebrity_image } = data;

  const myScore = myKey === 'p1' ? p1_score : p2_score;
  const oppScore = myKey === 'p1' ? p2_score : p1_score;
  const iWon = winner === myKey;
  const isTie = winner === null;

  const myWins = myKey === 'p1' ? round_wins.p1 : round_wins.p2;
  const oppWins = myKey === 'p1' ? round_wins.p2 : round_wins.p1;

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        {/* Result banner */}
        <div
          style={{
            ...styles.banner,
            background: isTie
              ? 'rgba(255,255,255,0.08)'
              : iWon
              ? 'linear-gradient(135deg, #22c55e22, #16a34a22)'
              : 'linear-gradient(135deg, #ef444422, #dc262622)',
            border: `1px solid ${isTie ? 'rgba(255,255,255,0.1)' : iWon ? '#22c55e40' : '#ef444440'}`,
          }}
        >
          <span style={styles.resultEmoji}>
            {isTie ? '🤝' : iWon ? '🏆' : '😔'}
          </span>
          <span
            style={{
              ...styles.resultText,
              color: isTie ? '#fff' : iWon ? '#22c55e' : '#ef4444',
            }}
          >
            {isTie ? 'Tie Round!' : iWon ? 'Round Won!' : 'Round Lost'}
          </span>
        </div>

        <p style={styles.roundLabel}>Round {round} of 3</p>

        {/* Celebrity reveal */}
        <div style={styles.revealSection}>
          <img src={celebrity_image} alt={celebrity_name} style={styles.revealImg} />
          <div style={styles.revealName}>{celebrity_name}</div>
        </div>

        {/* Scores */}
        <div style={styles.scores}>
          <div style={styles.scoreBox}>
            <span style={styles.scoreName}>You</span>
            <span style={styles.scoreVal}>{myScore}</span>
            <span style={styles.scoreLabel}>pts</span>
          </div>
          <div style={styles.scoreDivider}>vs</div>
          <div style={styles.scoreBox}>
            <span style={styles.scoreName}>{opponentName}</span>
            <span style={styles.scoreVal}>{oppScore}</span>
            <span style={styles.scoreLabel}>pts</span>
          </div>
        </div>

        {/* Round wins tracker */}
        <div style={styles.winsRow}>
          <span style={styles.winsLabel}>Rounds won:</span>
          <div style={styles.winsDots}>
            {[0, 1].map((i) => (
              <div
                key={`my-${i}`}
                style={{
                  ...styles.winDot,
                  background: i < myWins ? '#22c55e' : 'rgba(255,255,255,0.1)',
                }}
              />
            ))}
            <span style={styles.winsVs}>YOU — OPP</span>
            {[0, 1].map((i) => (
              <div
                key={`opp-${i}`}
                style={{
                  ...styles.winDot,
                  background: i < oppWins ? '#ef4444' : 'rgba(255,255,255,0.1)',
                }}
              />
            ))}
          </div>
        </div>

        {/* Countdown */}
        <p style={styles.countdown}>
          Next round in <span style={styles.countdownNum}>{countdown}</span>...
        </p>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 100,
    background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(12px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '20px',
  },
  card: {
    background: '#111127', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '24px', padding: '32px 28px',
    maxWidth: '360px', width: '100%',
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px',
  },
  banner: {
    width: '100%', padding: '14px 20px', borderRadius: '14px',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
  },
  resultEmoji: { fontSize: '28px' },
  resultText: { fontSize: '22px', fontWeight: '800', fontFamily: "'Syne', sans-serif" },
  roundLabel: { margin: 0, fontSize: '13px', color: 'rgba(255,255,255,0.4)' },
  revealSection: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0',
  },
  revealImg: {
    width: '120px', height: '120px', objectFit: 'cover',
    borderRadius: '16px', border: '2px solid #6366f1',
  },
  revealName: {
    marginTop: '8px', fontSize: '18px', fontWeight: '800',
    color: '#fff', fontFamily: "'Syne', sans-serif",
  },
  scores: { display: 'flex', alignItems: 'center', gap: '20px', width: '100%' },
  scoreBox: {
    flex: 1, display: 'flex', flexDirection: 'column',
    alignItems: 'center', gap: '2px',
    background: 'rgba(255,255,255,0.04)', borderRadius: '14px', padding: '12px',
  },
  scoreName: { fontSize: '12px', color: 'rgba(255,255,255,0.45)' },
  scoreVal: { fontSize: '32px', fontWeight: '900', color: '#fff', lineHeight: 1 },
  scoreLabel: { fontSize: '11px', color: 'rgba(255,255,255,0.3)' },
  scoreDivider: { fontSize: '13px', color: 'rgba(255,255,255,0.25)' },
  winsRow: { display: 'flex', alignItems: 'center', gap: '10px' },
  winsLabel: { fontSize: '12px', color: 'rgba(255,255,255,0.35)' },
  winsDots: { display: 'flex', alignItems: 'center', gap: '6px' },
  winDot: { width: '12px', height: '12px', borderRadius: '50%', transition: 'background 0.3s' },
  winsVs: { fontSize: '10px', color: 'rgba(255,255,255,0.2)', margin: '0 4px' },
  countdown: {
    margin: 0, fontSize: '14px', color: 'rgba(255,255,255,0.4)',
  },
  countdownNum: { color: '#6366f1', fontWeight: '800', fontSize: '18px' },
};